import configuredAxios from './axiosConfig'; // ajuste o caminho conforme seu projeto

const API_BASE_URL = '/standings'; // já com baseURL no axiosConfig

async function getOverallStandings(championshipId) {
  try {
    const response = await configuredAxios.get(`${API_BASE_URL}/${championshipId}`);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: error.message || 'Erro ao buscar classificação geral' };
  }
}

async function getGroupStandings(groupId) {
  try {
    const response = await configuredAxios.get(`${API_BASE_URL}/group/${groupId}`);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: error.message || 'Erro ao buscar classificação do grupo' };
  }
}

async function getGroupMatches(groupId) {
  try {
    const response = await configuredAxios.get(`${API_BASE_URL}/group/${groupId}/matches`);
    return { success: true, data: response.data };
  } catch (error) {
    return { success: false, error: error.message || 'Erro ao buscar partidas do grupo' };
  }
}

async function getGroupPreview(championshipId) {
  try {
    const response = await configuredAxios.get(`${API_BASE_URL}/${championshipId}/groups-preview`);
    return { success: true, data: response.data.data || response.data };
  } catch (error) {
    return { success: false, error: error.message || 'Erro ao buscar grupos' };
  }
}

export {
  getOverallStandings,
  getGroupStandings,
  getGroupMatches,
  getGroupPreview,
};
